<template>
    <div></div>
</template>
<script>
    export default {
        mounted: function () {
            let that = this;
            if (
                that.$store.state.onboarding &&
                !that.$store.state.onboarded.campaigns
            ) {
                // use this for debugging: if ( !this.$store.state.onboarded.campaigns ){
                this.$intro()
                    .setOptions({
                        showProgress: false,
                        showBullets: true,
                        steps: [
                            {
                                title: "Drip Campaigns",
                                intro: "Come here to create and edit as many drip campaigns as you want.",
                            },
                            {
                                title: "Select Campaign",
                                selector: "#campaignlist",
                                intro: "Select a campaign from the list to edit, or create a new one. We have pre-selected the included 'default' campaign for you.",
                                targetposition: "bottom",
                            },
                            {
                                title: "Connection Request",
                                selector: "#action0",
                                intro: "Write the body of the connection request message. You can use placeholders to personalize the message based on the target prospect. <br><br>This invitation will be sent to all prospects that are enrolled into the campaign which are not 1st degree connections.",
                                targetposition: "top",
                            },
                            {
                                title: "Follow-Up message",
                                selector: "#action1",
                                intro: "Specify the message body, add placeholders for personalization. <br><br>Specify the delay of the message, measured from the moment the prospect connects (2nd+ degree) or is enrolled (1st degree) into the campaign.",
                                targetposition: "top",
                            },
                            {
                                title: "More Actions",
                                selector: "#action1 .addaction",
                                intro: "You can add up to 11 drip actions per campaign.",
                                targetposition: "bottom",
                            },
                            {
                                title: "Placeholders",
                                selector: "#placeholders",
                                intro: "Use these placeholders to personalize your messages",
                                targetposition: "bottom",
                            },
                            {
                                title: "Off / On",
                                selector: ".switch",
                                intro: "Switch your campaign off, or back on again. Campaigns that are 'off' will not generate any activity. Don't forget to hit 'save' after changing this switch.",
                                targetposition: "bottom",
                            },
                            {
                                title: "Up Next",
                                intro: 'Once your are happy with the contents and timing of your messages it\'s time to enroll some prospects into the campaign.<br/><br/> 👉 <a target= "_blank" href="https://support.dux-soup.com/article/202-enrolling-basics"><strong>Show me how</strong></a> 👈',
                            },
                        ],
                    })
                    .onchange(function () {
                        let step = this._introItems[this._currentStep];
                        if (step.selector) {
                            step.element = document.querySelector(
                                step.selector,
                            );
                            if (step.element) {
                                step.position = step.targetposition;
                            } else {
                                step.position = "floating";
                                document.body.scrollTop = 0;
                            }
                        }
                        if (step.position == "floating") {
                            window.scrollTo(0, 0);
                        }
                        // complete onboarding when last step has been shown.
                        if (this._currentStep + 1 == this._introItems.length) {
                            that.$store.commit(
                                "completedOnboarding",
                                "campaigns",
                            );
                        }
                    })
                    .oncomplete(function () {
                        that.$store.commit("completedOnboarding", "campaigns");
                    })
                    .start();
            }
        },
    };
</script>
<style>
    .introjs-tooltip {
        min-width: 350px;
    }
</style>
